<template>
	<section class="Footer">
		<div class="Footer__Links">
			<router-link-component
				pathname="Kontakt"
				:linkText="$t('navigation.footerEntries.contact')"
			/>
			<router-link-component
				pathname="FAQ"
				:linkText="$t('navigation.footerEntries.faq')"
			/>
			<router-link-component
				pathname="Meinungen"
				:linkText="$t('navigation.footerEntries.testimonials')"
			/>
			<router-link-component
				pathname="Impressum"
				:linkText="$t('navigation.footerEntries.imprint')"
			/>
			<router-link-component
				pathname="Datenschutz"
				:linkText="$t('navigation.footerEntries.dataProtection')"
			/>
		</div>
		<div class="Footer__Copyright">© {{ year }} sos-p.com</div>
	</section>
</template>

<script>
import RouterLinkComponent from '@/components/RouterLinkComponent.vue'
export default {
	name: 'FooterComp',
	components: {
		RouterLinkComponent
	},
	data() {
		return {
			year: new Date().getFullYear()
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_navigation.json'),
			en: require('@/i18n/en/eng_navigation.json')
		}
	}
}
</script>

<style scoped lang="stylus">
.Footer {
	background: #000;
	font-size: 14px;
	padding: 40px 60px 30px 60px;
	position: relative;
	z-index: 1;
}

.Footer__Links {
	display: flex;
	width: 100%;
	justify-content: space-between;
	flex-wrap: wrap;
}
.Footer__Links > a {
	margin: 0 10px 20px 10px;
}
.Footer__Copyright {
	text-align: center;
	margin-top: 40px;
	font-size: 13px;
}
</style>
